import type { Event } from '@sixam/shared/events';

type EventLocation = Pick<Event, 'place_id' | 'place_lat' | 'place_lng' | 'place_name'>;

/** Universal Google Maps URL that opens the native app when it is installed. */
export function mapsUrl(event: EventLocation): string {
  if (event.place_id) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      event.place_name
    )}&query_place_id=${encodeURIComponent(event.place_id)}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${event.place_lat},${event.place_lng}`;
}

/** Universal Apple Maps URL. It opens the app on Apple devices and the web elsewhere. */
export function appleMapsUrl(event: EventLocation): string {
  return `https://maps.apple.com/?q=${encodeURIComponent(event.place_name)}&ll=${event.place_lat},${event.place_lng}`;
}

/** Universal Waze URL. It falls back to Waze's web experience when the app is unavailable. */
export function wazeMapsUrl(event: EventLocation): string {
  return `https://www.waze.com/ul?ll=${event.place_lat},${event.place_lng}&navigate=yes`;
}

/** Android geo URI, which hands the location to the user's installed map-app chooser. */
export function androidMapsUrl(event: EventLocation): string {
  const query = `${event.place_lat},${event.place_lng}(${event.place_name})`;
  return `geo:${event.place_lat},${event.place_lng}?q=${encodeURIComponent(query)}`;
}

/** Proxy URL for the server-rendered static map preview (key stays server-side). */
export function staticMapUri(lat: number, lng: number): string {
  return `/api/places/static-map?lat=${lat}&lng=${lng}`;
}
